import { Snackbar } from "@mui/material";
import MuiAlert, { type AlertProps } from "@mui/material/Alert";
import { useCdcScript } from "hooks/use-cdc-script";
import React, { useEffect } from "react";

const Toast = React.forwardRef<HTMLDivElement, AlertProps>(
  function Toast(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  },
);

export const CdcScriptStatus: React.FC = () => {
  const { error } = useCdcScript();
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    if (error) {
      setOpen(true);
    }
  }, [error]);

  const handleClose = (_event?: React.SyntheticEvent | Event) => {
    setOpen(false);
  };

  if (!error) {
    return null;
  }

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Toast onClose={handleClose} severity="error">
        CDC service error: {JSON.stringify(error)}
      </Toast>
    </Snackbar>
  );
};
